/** PKR only, whole rupees (SPEC §7: integer PKR, 1 to 500,000 per expense). */
export const MAX_EXPENSE = 500_000;

const grouping = new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 });

/** "Rs 2,800". Western digits in both languages, matching receipts. */
export function rs(amount: number): string {
  return `Rs ${grouping.format(amount)}`;
}

export function groupDigits(amount: number): string {
  return grouping.format(amount);
}

export type PadKey = '0' | '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8' | '9' | '00' | 'back';

/**
 * Applies one keypad press to the amount typed so far (digits only, no leading zeros,
 * capped at MAX_EXPENSE). Returns the new digit string; '' means nothing entered.
 */
export function pressKey(current: string, key: PadKey): string {
  let next: string;
  if (key === 'back') next = current.slice(0, -1);
  else if (key === '00') next = current === '' ? '' : current + '00';
  else next = current + key;
  next = next.replace(/^0+/, '');
  if (next.length > 6 || Number(next) > MAX_EXPENSE) return String(MAX_EXPENSE);
  return next;
}
